import type { ComponentProps } from 'react'
import { SessionStatus } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { SESSION_STATUS_KEYS } from '~/pages/backoffice/admin/sessions/session-status'

type IProps = Omit<ComponentProps<typeof Badge>, 'variant' | 'children'> & { status: SessionStatus | `${SessionStatus}` }

/** Statut d'une session (active / archivée), le même partout où il s'affiche. */
function SessionStatusBadge({ status, ...props }: IProps) {
  const { t } = useTranslation()
  return (
    <Badge variant={status === SessionStatus.ACTIVE ? 'default' : 'secondary'} {...props}>
      {t(SESSION_STATUS_KEYS[status as SessionStatus])}
    </Badge>
  )
}

export default SessionStatusBadge
